var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import * as _ from "lodash";
import { components } from "react-select";
import { ImgThemeConsumer, styled } from "../theme/ThemeHelpers";
import ImgSelect from "./ImgSelect";
import { appendPx } from "../theme/DefaultTheme";
import { Icon } from "..";
var IC = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: grid;\n    display: -ms-grid;\n    grid-template-columns: ", " calc(100% - ", ");\n    -ms-grid-columns: ", " calc(100% - ", ");\n    height: calc(", " + 8px);\n"], ["\n    display: grid;\n    display: -ms-grid;\n    grid-template-columns: ", " calc(100% - ", ");\n    -ms-grid-columns: ", " calc(100% - ", ");\n    height: calc(", " + 8px);\n"])), function (p) { return appendPx(p.theme.iconSize); }, function (p) { return appendPx(p.theme.iconSize); }, function (p) { return appendPx(p.theme.iconSize); }, function (p) { return appendPx(p.theme.iconSize); }, function (p) { return appendPx(p.theme.iconSize); });
var I = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding-top: ", ";\n    grid-column: 1;\n    -ms-grid-column: 1;\n    height: calc(", " + 8px);\n"], ["\n    padding-top: ", ";\n    grid-column: 1;\n    -ms-grid-column: 1;\n    height: calc(", " + 8px);\n"])), function (p) { return p.paddingTop; }, function (p) { return appendPx(p.theme.iconSize); });
var T = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    grid-column: 2;\n    -ms-grid-column: 2;\n    padding-left: 10px;\n    height: calc(", " + 8px);\n    line-height: calc(", " + 8px);\n"], ["\n    grid-column: 2;\n    -ms-grid-column: 2;\n    padding-left: 10px;\n    height: calc(", " + 8px);\n    line-height: calc(", " + 8px);\n"])), function (p) { return appendPx(p.theme.iconSize); }, function (p) { return appendPx(p.theme.iconSize); });
var IconOption = function (size, iconPaddingTop) { return function (props) {
    var data = props.data;
    return (React.createElement(components.Option, __assign({}, props),
        React.createElement(IC, null,
            React.createElement(I, { paddingTop: iconPaddingTop },
                React.createElement(Icon, { size: size, name: data.icon })),
            React.createElement(T, null, data.label))));
}; };
var IconValue = function (size, iconPaddingTop) { return function (props) {
    var data = props.data;
    return (React.createElement(IC, null,
        React.createElement(I, { paddingTop: iconPaddingTop },
            React.createElement(Icon, { size: size, name: data.icon })),
        React.createElement(T, null, data.label)));
}; };
var ImgIconSelect = function (p) {
    var onChange = p.onChange, isClearable = p.isClearable;
    var innerval = _.find(p.options, function (o) { var _a; return o.value === ((_a = p.value) === null || _a === void 0 ? void 0 : _a.value); });
    var chg = React.useMemo(function () { return function (val) {
        if (onChange)
            onChange(val);
    }; }, [onChange]);
    return (React.createElement(ImgThemeConsumer, null, function (theme) { return (React.createElement(ImgSelect, { value: innerval, options: p.options, components: {
            Option: IconOption(theme.iconSize, "0px"),
            SingleValue: IconValue(theme.iconSize, "0px")
        }, onChange: chg, isMulti: false, isClearable: isClearable })); }));
};
export default ImgIconSelect;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=ImgIconSelect.js.map